import { render } from "./RequestExpired.vue?vue&type=template&id=dc2c5732"
import script from "./RequestExpired.vue?vue&type=script&lang=js"
export * from "./RequestExpired.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__